import { Paragraph, Heading } from '@hungryroot/ramen';
import styles from './TextSection.module.css';

interface Props {
  testid?: string;
  heading: string;
  body: string;
  className?: string;
}

export function TextSection(props: Props) {
  const { testid, heading, body, className } = props;

  return (
    <div data-testid={testid} className={className}>
      <Heading
        variant="Hero"
        className={styles.heading}
        testid={`${testid}-heading`}
      >
        {heading}
      </Heading>
      <Paragraph variant="lead" testid={`${testid}-body`}>
        {body}
      </Paragraph>
    </div>
  );
}
